// const baseUrl = "https://edhilara.ikodestudio.com/api";
// const baseUrl = "https://staging.edhi.org.au/api";
const baseUrl = "https://api.edhi.org.au/api";

export default baseUrl;
